import type { RequestInterface } from '~/common/types';
import { NotificationRequest } from '~/notifications/types';

export class NotificationsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/notifications';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetNotificationRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    notificationId,
    params,
  }: {
    token: string;
    notificationId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/notifications/${notificationId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class CreateNotificationRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/notifications';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    notification,
  }: {
    token: string;
    notification: NotificationRequest;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...notification,
    };
  }
}

export class UpdateNotificationRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    notificationId,
    notification,
  }: {
    token: string;
    notificationId: string;
    notification: NotificationRequest;
  }) {
    this.path = `/api/v1/notifications/${notificationId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...notification,
    };
  }
}

export class DeleteNotificationRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({
    token,
    notificationId,
  }: {
    token: string;
    notificationId: string;
  }) {
    this.path = `/api/v1/notifications/${notificationId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}
